// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'

Vue.config.productionTip = true;

import VueResource from 'vue-resource';
import 'babel-polyfill'
import 'es6-promise/auto'

// 引入element UI的css 和 插件
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import '../static/css/detail.css';

//视频预览
import Video from 'video.js'
import 'video.js/dist/video-js.css'
Vue.prototype.$video = Video;

Vue.use(ElementUI);
Vue.use(VueResource);

import * as utils from "@/utils/util";
Vue.prototype.util = utils;

import VueUeditorWrap from 'vue-ueditor-wrap'
Vue.component('vue-ueditor-wrap', VueUeditorWrap)

// 引入组件
import projectFile_visitLog from './components/projectFile_visitLog.vue';
import inputs from './components/c-input.vue';
import datepicker from './components/TimePicker.vue';
import select from './components/c-select.vue';
// import next_plan from '../components/next_plan.vue';
import selectObj from './components/selectObj_user.vue';
import texts from './components/c-text.vue';
import select_flow from './components/select_flow.vue';
import selectFile from './components/filelist.vue';
import filelist_multiple from './components/filelist_multiple.vue';
import audit from './components/audit.vue';
import editor from './components/editor.vue' ;
import uc_editor from './components/ue_editor';
import addProjectpage from './components/addProjectpage.vue';
import edit_project from './components/edit_project.vue';

Vue.component('v-projectFile_visitLog', projectFile_visitLog)
Vue.component('v-input', inputs)
Vue.component('v-datepicker', datepicker)
Vue.component('v-select', select)
Vue.component('v-selectObj', selectObj)
Vue.component('v-text', texts)
Vue.component('v-select_flow', select_flow)
Vue.component('v-selectFile', selectFile)
Vue.component('v-audit', audit)
Vue.component('v-filelist_multiple', filelist_multiple)
Vue.component('editor', editor)
Vue.component('uc_editor', uc_editor)
Vue.component('v-addProjectpage', addProjectpage)
Vue.component('v-edit_project', edit_project)
/* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    components: { App },
    template: '<App/>'
})


// WEBPACK FOOTER //
// ./src/main.js